import React from 'react';
import { motion } from 'framer-motion';
import { SparkleEffect } from '../components/SparkleEffect';
import { ClipboardListIcon, PaletteIcon, FileTextIcon, ExternalLinkIcon, LockIcon, SparklesIcon } from 'lucide-react';
export function ChecklistsPage() {
  const checklists = [{
    name: '1 Hour Emergency Hot Mess Clean',
    price: '$2.99',
    description: "For when someone's coming over and you waited till the last minute. This checklist gets your place looking put-together in 60 minutes flat—no judgment, just results.",
    includes: ['Editable Canva template', 'Printable PDF'],
    link: 'https://trippinwithmandy.gumroad.com/l/bklnc',
    accent: 'from-blush-100/40 to-cta-100/30',
    borderColor: 'border-blush-200/50',
    icon: '🧹',
    comingSoon: false
  }, {
    name: 'Weekly Meal Prep Made Simple',
    price: '$2.99',
    description: 'Stop staring at the fridge wondering what to eat. Plan your week in 15 minutes so you actually eat like a functioning human.',
    includes: ['Editable Canva template', 'Printable PDF'],
    link: '',
    accent: 'from-lavender-100/40 to-white/30',
    borderColor: 'border-lavender-200/50',
    icon: '🍳',
    comingSoon: true
  }, {
    name: 'Morning Routine Reset',
    price: '$2.99',
    description: "Build a morning that doesn't start with doom-scrolling. A step-by-step checklist to create a routine that actually sets you up for the day.",
    includes: ['Editable Canva template', 'Printable PDF'],
    link: '',
    accent: 'from-sky-100/40 to-white/30',
    borderColor: 'border-sky-200/50',
    icon: '☀️',
    comingSoon: true
  }, {
    name: 'Budget Reset Checklist',
    price: '$2.99',
    description: 'Get your money right without the guilt trip. A no-shame checklist to take control of your finances one step at a time.',
    includes: ['Editable Canva template', 'Printable PDF'],
    link: '',
    accent: 'from-green-100/40 to-white/30',
    borderColor: 'border-green-200/50',
    icon: '💰',
    comingSoon: true
  }, {
    name: 'Self-Care Sunday Planner',
    price: '$2.99',
    description: 'Because you deserve more than just surviving the week. Plan a reset day that actually recharges you.',
    includes: ['Editable Canva template', 'Printable PDF'],
    link: '',
    accent: 'from-blush-100/40 to-lavender-100/30',
    borderColor: 'border-blush-200/50',
    icon: '🫧',
    comingSoon: true
  }, {
    name: 'Moving Day Survival Guide',
    price: '$2.99',
    description: 'Moving is chaos. This checklist keeps you sane from packing to unpacking so nothing gets forgotten.',
    includes: ['Editable Canva template', 'Printable PDF'],
    link: '',
    accent: 'from-amber-100/40 to-white/30',
    borderColor: 'border-amber-200/50',
    icon: '📦',
    comingSoon: true
  }];
  const activeChecklists = checklists.filter(c => !c.comingSoon);
  const comingSoonChecklists = checklists.filter(c => c.comingSoon);
  return <div className="min-h-screen pt-24 pb-24 relative" data-id="element-347">
      {/* Background */}
      <img src="https://cdn.magicpatterns.com/uploads/oG4RFfihdYAxazP48DHh8y/ChatGPT_Image_Mar_21,_2026,_09_37_08_PM.png" alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-contain object-top pointer-events-none z-0" data-id="element-348" />
      <div className="absolute inset-0 bg-gradient-to-b from-white/60 via-white/40 to-white/70 z-0" data-id="element-349" />

      {/* Hero */}
      <section className="relative py-20 text-center overflow-hidden" data-id="element-350">
        <SparkleEffect count={90} data-id="element-351" />
        <div className="max-w-3xl mx-auto px-4 relative z-10" data-id="element-352">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/40 backdrop-blur-sm border border-blush-200/50 text-sm font-bold text-plum-700 mb-6 uppercase tracking-wider" data-id="element-353">
            <ClipboardListIcon className="w-4 h-4 text-cta-500" data-id="element-354" />
            From The Ultimate Checklist Guide
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="font-heading text-5xl md:text-6xl font-bold text-plum-700 mb-6" data-id="element-355">
            Grab Individual <span className="text-cta-500" data-id="element-356">Checklists</span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="text-xl text-plum-500 font-medium max-w-2xl mx-auto" data-id="element-357">
            Don't need the whole guide? Snag the ones you need right now. Each
            comes with a digital Canva template and a printable PDF.
          </motion.p>
        </div>
      </section>

      {/* Active Checklists */}
      {activeChecklists.length > 0 && <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-24 relative z-10" data-id="element-358">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-359">
            {activeChecklists.map((item, i) => <motion.a key={i} href={item.link} target="_blank" rel="noopener noreferrer" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`group relative bg-gradient-to-br ${item.accent} backdrop-blur-sm ${item.borderColor} border rounded-[2rem] p-8 shadow-sm hover:shadow-xl hover:-translate-y-2 transition-all duration-300 flex flex-col`} data-id="element-360">
                <div className="text-5xl mb-6" data-id="element-361">{item.icon}</div>

                <h3 className="font-heading text-2xl font-bold text-plum-700 mb-3 leading-snug" data-id="element-362">
                  {item.name}
                </h3>

                <p className="text-plum-500 font-medium mb-6 flex-grow" data-id="element-363">
                  {item.description}
                </p>

                <div className="space-y-3 mb-8" data-id="element-364">
                  {item.includes.map((inc, j) => <div key={j} className="flex items-center gap-2 text-sm font-bold text-plum-600" data-id="element-365">
                      {j === 0 ? <PaletteIcon className="w-4 h-4 text-cta-500 shrink-0" data-id="element-366" /> : <FileTextIcon className="w-4 h-4 text-cta-500 shrink-0" data-id="element-367" />}
                      {inc}
                    </div>)}
                </div>

                <div className="flex items-center justify-between mt-auto pt-6 border-t border-plum-100/30" data-id="element-368">
                  <span className="font-heading text-3xl font-bold text-plum-700" data-id="element-369">
                    {item.price}
                  </span>
                  <span className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-cta-500 text-white font-bold text-sm group-hover:bg-cta-600 transition-colors shadow-lg shadow-cta-500/20" data-id="element-370">
                    Get It
                    <ExternalLinkIcon className="w-4 h-4" data-id="element-371" />
                  </span>
                </div>
              </motion.a>)}
          </div>
        </section>}

      {/* Coming Soon Checklists */}
      {comingSoonChecklists.length > 0 && <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-372">
          <div className="text-center mb-12" data-id="element-373">
            <h2 className="font-heading text-3xl font-bold text-plum-700 mb-3" data-id="element-374">
              More Dropping Soon
            </h2>
            <p className="text-plum-500 font-medium" data-id="element-375">
              New checklists added regularly. Check back often!
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-376">
            {comingSoonChecklists.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`relative bg-gradient-to-br ${item.accent} backdrop-blur-sm ${item.borderColor} border rounded-[2rem] p-6 shadow-sm opacity-75 transition-all duration-300 flex flex-col`} data-id="element-377">
                <div className="absolute top-4 right-4 px-3 py-1 bg-white/80 text-plum-500 text-xs font-bold rounded-full uppercase tracking-wider flex items-center gap-1 border border-plum-100" data-id="element-378">
                  <LockIcon className="w-3 h-3" data-id="element-379" /> Coming Soon
                </div>

                <div className="text-4xl mb-4" data-id="element-380">{item.icon}</div>

                <h3 className="font-heading text-lg font-bold text-plum-700 mb-2 leading-snug" data-id="element-381">
                  {item.name}
                </h3>

                <p className="text-plum-500 text-sm font-medium mb-4 flex-grow" data-id="element-382">
                  {item.description}
                </p>

                <div className="space-y-2 mb-5" data-id="element-383">
                  {item.includes.map((inc, j) => <div key={j} className="flex items-center gap-2 text-xs font-bold text-plum-600" data-id="element-384">
                      {j === 0 ? <PaletteIcon className="w-3.5 h-3.5 text-cta-500 shrink-0" data-id="element-385" /> : <FileTextIcon className="w-3.5 h-3.5 text-cta-500 shrink-0" data-id="element-386" />}
                      {inc}
                    </div>)}
                </div>

                <div className="flex items-center justify-between mt-auto pt-4 border-t border-plum-100/30" data-id="element-387">
                  <span className="font-heading text-2xl font-bold text-plum-700" data-id="element-388">
                    {item.price}
                  </span>
                  <span className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-plum-200/50 text-plum-500 font-bold text-xs" data-id="element-389">
                    <LockIcon className="w-3 h-3" data-id="element-390" />
                    Soon
                  </span>
                </div>
              </motion.div>)}
          </div>
        </section>}
    </div>;
}